import { styled } from '@mui/system';
import { Button, Box } from '@mui/material';

export const StyledButton = styled(Button)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  letterSpacing: 'inherit',
  fontWeight: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  textTransform: 'inherit',
  textAlign: 'inherit'
}));

export const ProjectTitle = styled('span')(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.grey[700],
  maxWidth: 150,
  overflow: 'hidden',
  wordWrap: 'break-word',
  display: 'block'
}));

export const AddressbookLabelText = styled(Box)(() => ({
  maxWidth: 150,
  overflow: 'hidden',
  wordWrap: 'break-word'
}));
